module.exports = __webpack_public_path__ + "img/fly.9042480c.png";